import React, { useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Container } from "../../common/layout/styels";
import { MenuGroupItem } from "../settings/styels";
// import withLayout from "../../../public/layout";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 2rem 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LeftColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  // padding: 0 100px;
  margin: 20px;
  max-width: 768px;
`;

const RightColumn = styled.div`
  flex: 1;
  background: #f9f9f9;
  border-left: 4px solid #3FC4FD;
  padding: 1.5rem;
  font-style: italic;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Heading = styled.h2`
  margin: 0;
  margin-bottom: 0.5rem;
  color: #222;
`;

const Heading2 = styled.h3`
  margin: 0;
  // margin-top: 20px;
  color: #0000aaff;
  text-transform: uppercase;
`;

const SubHeading = styled.h3`
  margin-bottom: 1rem;
  margin-top: 0;
  font-weight: 700;
//   color: #3FC4FD;
`;

const Paragraph = styled.p`
  margin: 0;
  line-height: 1.6;
`;

const Link = styled.a`
  color: #000000;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #3FC4FD;
  }
`;

const Support = (props) => {
  const { t } = useTranslation();
  const [user] = useState(props.user.user);

  return (
    <Container className="noshadow column" style={{padding: '0'}}>
      
        {/* Left Section */}
        <LeftColumn>
          <Heading2>{t("Contact Support")}</Heading2>
          <Heading>{t("Contact Us")}</Heading>
          <Paragraph>
            {t("ContactSupportDescription")}
          </Paragraph>

<Wrapper>
          <MenuGroupItem className="support">
            <SubHeading>{t("emailSupport")}</SubHeading>
            <Paragraph style={{fontSize: "18px"}}>
              <Link href={`mailto:support@whistleblowing24.com?subject=${encodeURIComponent(`${t("Customer number")} ${user?.customerNumber} / ${t("Company name")} ${user?.companyName} / ${t("Internal support")}`)}`}>
                support@whistleblowing24.com
              </Link>
            </Paragraph>
          </MenuGroupItem>

          <MenuGroupItem className="support">
            <SubHeading>{t("telefonSupport")}</SubHeading>
            <Paragraph style={{fontSize: "18px"}}>
              <Link href="tel:+4908131360180">+49 (0) 8131 360180</Link>
            </Paragraph>
          </MenuGroupItem>
          </Wrapper>

          {/* <div>
            <SubHeading>
              {t("meetingSupport")}
            </SubHeading>
            <Paragraph>
              <Link href="#" target="_blank" rel="noopener noreferrer">
                {t("meetingLink")}
              </Link>
            </Paragraph>
          </div> */}
        </LeftColumn>

        {/* Right Section */}
        {/* <RightColumn>
          {t("supportRightContent")}
        </RightColumn> */}
    </Container>
  );
};

export default Layout(Support);
